module.exports = __webpack_public_path__ + "static/media/imageedit_10_5728340730.d04034d3.jpg";